module.exports = __webpack_public_path__ + "img/mp.87e1b09e.svg";